/* eslint-disable react-hooks/exhaustive-deps */
import { Check, Close, CloudUpload, DeleteOutline, Download, Save } from "@mui/icons-material";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, Divider, Link, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, TableContainer, Table, TableHead, TableRow, TableBody, styled, TableCell, Drawer, IconButton, FormGroup, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogActions, DialogContent, TextField, Tooltip, Card, Tabs, Tab, CircularProgress, Autocomplete, RadioGroup, Radio, OutlinedInput } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from "react";
import { gropuing, groupingFields, headingsLayout, idsLayout, locationIdLayout, marginsLayout, prevColRoomDetailWithoutPrice, prevColRoomDetailWithPrice, prevColRoomListPrice, prevColRoomListWithoutPrice, previewDataSheetColumns, previewDataSheetTableColumns, previewItemDetailColumns, previewItemLocColumns, previewItemSpecColumns, previewItemSummary, previewPOActionColumns, previewPointIntimeColumns, previewPoSummaryColumns, previewProcurementColumns, previewProcurementScheduleColumns, previewProjectCeritifiColumns, previewProjectItemSummColumns, previewRoomDataDetailColumns, previewRoomDataSpecColumns, ReportFormats, ReportType, sortingFields, tableNames } from "../../../common/const";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { ClearIcon } from "@mui/x-date-pickers";
import DragDrop from "../../../common/DragDrop";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getOrganization } from "../../../redux/Actions/orgAction";
import DynamicTable from "../../../common/DynamicTable";
import FilterPanel from "./ReportFilterPanel";
import moment from "moment";
import { apiRequest } from "../../../common/common";
import { LoadingPage } from "../../../common/LoadingPage";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { io } from "socket.io-client";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Cell = styled(TableCell)({
  padding: '0px 0px 0px 20px'
});

const CustomFilterPanelWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: 10,
});

const DemoBox1 = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: 60
}));

const FilterContent = styled(Box)({
  flexGrow: 1,         // Take up available space
  overflowY: 'auto',   // Enable scrolling if content overflows
  paddingBottom: 30,   // Ensure space for the fixed footer
  paddingTop: 10
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
  position: 'sticky',
  bottom: 0,
  display: 'flex',
  gap: 5
});

// Fixed button in the footer
const FixedButton = styled(Button)({
  width: '100%',
});

const DemoTabs = styled(Tabs)(({ theme }) => ({
  minWidth: 200,
  borderBottom: '1px solid #e8e8e8',
  [theme.breakpoints.down('xs')]: {
    marginLeft: '0%',
  },
  [theme.breakpoints.down('md')]: {
    minWidth: '20px',
    fontSize: 10,
  },
}));

const DemoTab = styled(Tab)(({ theme }) => ({
  minWidth: 110,
  fontSize: 18,
  textTransform: 'capitalize',
  fontFamily: 'open sans',
  fontWeight: 'bold',
  [theme.breakpoints.down('xs')]: {
    minWidth: 8,
    fontSize: 10,
  },
  '&:hover': {
    backgroundColor: '#f6f7ff',
    color: 'black',
  },
}));

const Reports = ({
  projectId,
  organizationId,
  clientOrganization,
  clientLogos,
  fromAdmin,
  setReportSetting,
  activeMainTab
}) => {
  const dispatch = useDispatch();
  const { organization } = useSelector(state => state.organizations);
  const { user, roles } = useSelector((state) => state.users);
  const isUser = roles.find((a) => a.id === user?.role_id);
  const [dataLoading, setDataLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [columns, setColumns] = useState([]);
  const [anotherColumns, setAnotherColumns] = useState([]);
  const [selectReport, setSelectReport] = useState(false);
  const [reportName, setReportName] = useState(null);
  const [savedReport, setSavedReport] = useState(null);
  const [description, setDescription] = useState(null);
  const [selectedReport, setSelectedReport] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [reportType, setReportType] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [sortby, setSortBy] = useState(null);
  const [groupby, setGroupBy] = useState([]);
  const [isLayoutEdit, setLayoutEdit] = useState(false);
  const [filters, setFilters] = useState([]);
  const [saveOpen, setSaveOpen] = useState(false);
  const [customReports, setCustomReports] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [reportId, setReportId] = useState(false);
  const [settings, setSettings] = useState(null);
  const [depData, setDepData] = useState([]);
  const [roomData, setRoomData] = useState([]);
  const [pointData, setPointData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [isDataAvailable, setIsDataAvailable] = useState(true);
  const [filter, setFilter] = useState({
    table: '',
    from: '',
    to: ''
  })

  const toggleExpand = (index) => {
    setExpandedRows(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  const handleClose = () => {
    setLayoutEdit(false);
    setFilterOpen(false);
  }

  useEffect(() => {
    if (organizationId) {
      dispatch(getOrganization({
        organizationId
      }));
    }
  }, [organizationId]);

  const getCustomReports = async () => {
    try {
      setDataLoading(true);
      const response = await apiRequest('get', `/report?organizationId=${organizationId}`);
      const { data } = response.data;
      setCustomReports(data);
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    getCustomReports();
  }, [organizationId]);

  const getReportHistory = async (page) => {
    try {
      if (projectId && activeTab === 1) {
        setDataLoading(true);
        const response = await apiRequest('get', `/report/report-history?projectId=${projectId}&pageNo=${page}&pageSize=10`);
        const { data } = response.data;
        if (data.length === 0) {
          setIsDataAvailable(false);
        }
        setReportData((prevData) => {
          const newData = [...prevData, ...data]; // Merge old and new data
          const uniqueData = [
            ...new Map(newData.map(item => [item.report_history_id, item])).values(),
          ];
          return uniqueData;
        });
        setDataLoading(false);
      }
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    getReportHistory(1);
  }, [projectId, activeTab]);

  const getRooms = async () => {
    const url = [
      `/project-room?projectId=${projectId}`,
      settings?.department_ids?.length > 0 ? `&departmentIds=${settings?.department_ids.toString()}` : '',
      `pageNo=1`,
      `pageSize=100`,
    ].filter(Boolean).join('&');
    try {
      const response = await apiRequest('get', `${url}`);
      const { data } = response.data;
      setRoomData(data);
      setSettings((prev) => ({
        ...prev,
        room_ids: data.filter((a) => settings?.room_ids?.includes(a.room_id))?.map((a) => a.room_id)
      }));
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getDepartment = async () => {
    const url = [
      `/department?projectId=${projectId}`,
      `pageNo=1`,
      `pageSize=100`,
    ].filter(Boolean).join('&');
    try {
      const response = await apiRequest('get', `${url}`);
      const { data } = response.data;
      setDepData(data);
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const getPointInTime = async () => {
    try {
      setDataLoading(true);
      const response = await apiRequest('get', `/point-in-time?projectId=${projectId}`);
      if (response.data) {
        setPointData(response?.data?.data);
        setDataLoading(false);
      }
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    if (projectId) {
      getPointInTime();
    }
  }, [projectId]);

  useEffect(() => {
    if (selectedReport && selectedReport.type === ReportType[29]) {
      getDepartment();
    }
  }, [selectedReport]);

  useEffect(() => {
    if (settings?.department_ids?.length > 0) {
      getRooms();
    } else {
      setRoomData([]);
      setSettings((prev) => ({
        ...prev,
        room_ids: []
      }));
    }
  }, [settings?.department_ids]);

  useEffect(() => {
    if (activeMainTab === 'Reports') {
      // Create new socket instance for reports tab
      const socket = io("https://app.mvedas.com");

      socket.emit("register", user.user_id);

      socket.on("reportStatus", (data) => {
        setReportData((prevData) => {
          return prevData.map((item) => {
            // Check if report_history_id matches
            if (item.report_history_id === data?.data?.report_history_id) {
              return {
                ...item,
                status: data?.data?.status,
                output_file_url: data?.data?.output_file_url
              };
            }
            return item;
          });
        });
      });

      socket.on("connect", () => {
        console.log('Connected to reports socket');
      });

      // Cleanup - disconnect when leaving reports tab
      return () => {
        console.log('Disconnecting reports socket');
        socket.disconnect();
      };
    }
  }, [activeMainTab, user.user_id]);

  return (
    <Box mb={1} mt={1}>
      {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
      <Dialog open={deleteOpen} fullWidth maxWidth="xs">
        <DialogContent>
          <Typography>Are you sure to delete this?</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              setDeleteOpen(false);
              setReportId(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={async () => {
              setDataLoading(true);
              try {
                const response = await apiRequest('delete', `/report/${reportId}`);
                if (response.data) {
                  setDeleteOpen(false);
                  setReportId(null);
                  getCustomReports();
                  showNotification('Reports setting deleted successfully', 'success');
                }
                setDataLoading(false);
              } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
              }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={saveOpen} fullWidth maxWidth="xs">
        <DialogTitle>Save Setting</DialogTitle>
        <Divider />
        <DialogContent style={{ padding: '10px 8px' }}>
          <TextField
            label="Report Name"
            name="reportname"
            variant="outlined"
            fullWidth
            size='small'
            value={savedReport}
            onChange={(e) => {
              setSavedReport(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              setSaveOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={async () => {
              if (reportName !== null) {
                setDataLoading(true);
                const data = {
                  name: savedReport,
                  fields: reportType === ReportType[13] ? columns.map((a) => {
                    if (a?.subHeaders) {
                      // Modify subHeaders array
                      const updatedSubHeaders = a.subHeaders.map((d) => {
                        if (d.field === 'quantity') {
                          return {
                            ...d, // Spread existing properties of subHeader
                            field: 'extended_item_quantity' // Update the field value in subHeader
                          }
                        }
                        return d; // Return unchanged subHeader if condition is not met
                      });

                      return {
                        ...a, // Spread the top-level object
                        subHeaders: updatedSubHeaders // Update subHeaders with modified values
                      };
                    }

                    return a; // Return the object unchanged if no subHeaders exist
                  }) : columns,
                  columns: anotherColumns,
                  filters: filters,
                  groupby: groupby,
                  sortby: sortby === 'description ' ? ['category_name'] : [sortby],
                  type: reportType,
                  status: "active",
                  project_id: projectId,
                  organization_id: organizationId,
                  output: settings?.outPut,
                  settings: settings,
                  description: description,
                  accessories_type: ''
                };
                try {
                  let response = null;
                  if (selectedReport.report_id) {
                    response = await apiRequest('put', `/report/${selectedReport.report_id}`, data);
                    if (response.data) {
                      showNotification('Report settings updated successfully', 'success');
                    }
                  } else {
                    response = await apiRequest('post', '/report', data);
                    if (response.data) {
                      showNotification('Report settings saved successfully', 'success');
                    }
                  }
                  setSavedReport(null);
                  setSaveOpen(false);
                  getCustomReports();
                  setDataLoading(false);
                } catch (error) {
                  setDataLoading(false);
                  showNotification(error?.response?.data.error || error.message, 'error');
                }
              } else {
                showNotification('Please enter report name', 'error');
              }
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" style={{ fontWeight: 'bold' }}>Reporting</Typography>
        {reportName !== null ? (
          <Box>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<CloudUpload />}
              style={{ marginRight: 10 }}
              onClick={async () => {
                const data = {
                  projectId: projectId,
                  sortby: sortby !== "" ? sortby === 'description ' ? 'category_name' : sortby : null,
                  filters: filters,
                  report_type: reportType,
                  report_name: reportName,
                  settings: settings,
                  fields: [ReportType[31], ReportType[32], ReportType[33], ReportType[34], ReportType[35], ReportType[36], ReportType[37], ReportType[38]].includes(reportType) ? columns.map((a) => {
                    if (a?.subHeaders) {
                      // Modify subHeaders array
                      const updatedSubHeaders = a.subHeaders.map((d) => {
                        if (d.field === 'quantity') {
                          return {
                            ...d, // Spread existing properties of subHeader
                            title: 'Qty',
                            field: 'extended_item_quantity' // Update the field value in subHeader
                          }
                        }
                        if (d.field === 'list_price') {
                          return {
                            ...d,
                            title: 'Unit Cost'
                          }
                        }
                        return d; // Return unchanged subHeader if condition is not met
                      });

                      return {
                        ...a, // Spread the top-level object
                        subHeaders: updatedSubHeaders // Update subHeaders with modified values
                      };
                    }

                    return a; // Return the object unchanged if no subHeaders exist
                  }) : reportType === ReportType[13] ? columns.map((a) => {
                    if (a?.subHeaders) {
                      // Modify subHeaders array
                      const updatedSubHeaders = a.subHeaders.map((d) => {
                        if (d.field === 'quantity') {
                          return {
                            ...d, // Spread existing properties of subHeader
                            field: 'extended_item_quantity' // Update the field value in subHeader
                          }
                        }
                        return d; // Return unchanged subHeader if condition is not met
                      });

                      return {
                        ...a, // Spread the top-level object
                        subHeaders: updatedSubHeaders // Update subHeaders with modified values
                      };
                    }

                    return a; // Return the object unchanged if no subHeaders exist
                  }) : columns,
                  columns: anotherColumns,
                  groupby: groupby.length > 0 ? groupby : [ReportType[23], ReportType[24], ReportType[25], ReportType[26], ReportType[27]].includes(reportType) ? gropuing : null,
                  output: settings.outPut
                }
                setDataLoading(true);
                try {
                  let response;
                  if ([ReportType[13], ReportType[14], ReportType[29]]?.includes(reportType)) {
                    if ((!data.settings?.room_ids || data.settings?.room_ids?.length === 0) && reportType === ReportType[29]) {
                      setDataLoading(false);
                      showNotification('Please select rooms before generate report', 'error');
                      return;
                    }
                    response = await apiRequest('post', '/report/project-datasheet', data);
                  } else if ([ReportType[1], ReportType[2], ReportType[3], ReportType[4], ReportType[5],
                  ReportType[6], ReportType[7], ReportType[8], ReportType[9], ReportType[10],
                  ReportType[11], ReportType[12], ReportType[28]].includes(reportType)) {
                    response = await apiRequest('post', '/report/budget', data);
                  } else if ([ReportType[30], ReportType[31], ReportType[32], ReportType[33], ReportType[34], ReportType[35], ReportType[36], ReportType[37], ReportType[38], ReportType[39], ReportType[40]].includes(reportType)) {
                    response = await apiRequest('post', '/report/purchase-module-report', data);
                  } else if (reportType === ReportType[41]) {
                    response = await apiRequest('get', `/audit-log/report/${projectId}?report_name=${reportName}&report_type=${reportType}${`${filter.table !== '' || filter.from !== '' || filter.to !== '' ? `&filters=${JSON.stringify(filter)}` : ''} `}`);
                  } else if ([ReportType[19], ReportType[20]]?.includes(reportType)) {
                    response = await apiRequest('post', '/report/pointin-time-report', data);
                  } else {
                    response = await apiRequest('post', '/report/item-details', data);
                  }
                  if (response.data) {
                    showNotification('Report generation process is ongoing.', 'success');
                    setFilter({
                      table: '',
                      from: '',
                      to: ''
                    })
                  }
                  setSelectReport(false);
                  setSelectedReport(null);
                  setDescription(null);
                  setReportName(null);
                  setReportType(null);
                  setSortBy(null);
                  setGroupBy([]);
                  setFilters([]);
                  setActiveTab(1);
                  setReportData([]);
                  getReportHistory(1);
                  setDataLoading(false);
                } catch (error) {
                  setDataLoading(false);
                  showNotification(error?.response?.data.error || error.message, 'error');
                }
              }}
            >
              Generate Report
            </Button>
            {['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) ? (
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<Save />}
                onClick={() => {
                  setSaveOpen(true);
                  setSavedReport(selectedReport?.name || `${reportName}-${moment().format('YYYY-MM-DD HH:MM A')}`);
                }}
              >
                Save Setting
              </Button>
            ) : selectedReport.report_id ? (
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<Save />}
                onClick={() => {
                  setSaveOpen(true);
                  setSavedReport(selectedReport?.name || `${reportName}-${moment().format('YYYY-MM-DD HH:MM A')}`);
                }}
              >
                Save Setting
              </Button>
            ) : ''}
            {fromAdmin && (
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<Close />}
                style={{ marginLeft: 10 }}
                onClick={() => {
                  setReportSetting(false);
                }}
              >
                Close
              </Button>
            )}
          </Box>
        ) : (
          <Box>
            {fromAdmin && (
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<Close />}
                style={{ marginLeft: 10 }}
                onClick={() => {
                  setReportSetting(false);
                }}
              >
                Close
              </Button>
            )}
          </Box>
        )}
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <DemoTabs
          value={activeTab}
          variant="scrollable"
          scrollButtons="auto"
        >
          <DemoTab
            label="Generate Report"
            value={0}
            onClick={() => {
              setActiveTab(0);
              setSelectReport(false);
              setSelectedReport(null);
              setDescription(null);
              setReportName(null);
              setReportType(null);
              setSortBy(null);
              setActivePage(1);
              setGroupBy([]);
              setFilters([]);
            }} />
          {projectId && (
            <DemoTab
              label="Past Reports"
              value={1}
              onClick={() => {
                setActiveTab(1);
                setSelectReport(false);
                setSelectedReport(null);
                setDescription(null);
                setReportName(null);
                setReportType(null);
                setSortBy(null);
                setGroupBy([]);
                setActivePage(1);
                setFilters([]);
              }} />
          )}
        </DemoTabs>
      </Box>
      {activeTab === 0 && (
        <Box mt={1}>
          <Typography variant="body1" style={{ fontWeight: 'bold' }}>Report Builder</Typography>
          <Grid container mb={2}>
            <Grid item xs={12} sm={reportName !== null ? 4 : 3}>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <Box style={{ display: 'flex', gap: 5, alignItems: 'center', marginTop: 10 }}>
                    <Typography variant="body2">Report Name: </Typography>
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <Link
                        style={{
                          fontSize: 14,
                          textDecoration: 'none',
                          cursor: 'pointer'
                        }}
                        onClick={() => setSelectReport(!selectReport)}
                      >
                        {reportName || 'Select a Report'}
                      </Link>
                      <KeyboardArrowRightIcon color="primary" />
                    </Box>
                  </Box>
                </Grid>
                {(reportName && !selectReport) && (
                  <>
                    {reportType === ReportType[29] ? (<Grid item xs={12} sm={12}>
                      <Box style={{ display: 'flex', gap: 5, alignItems: 'center', marginTop: 10 }}>
                        <Typography variant="body2">Rooms: </Typography>
                        <Autocomplete
                          value={depData.filter((c) => settings?.department_ids?.includes(c.department_id)) || []}
                          id="checkboxes-tags-demo"
                          size="small"
                          fullWidth
                          multiple
                          clearIcon={true}
                          disableCloseOnSelect
                          options={depData}
                          getOptionLabel={(option) => option?.department_name}
                          renderOption={(props, option, { selected }) => {
                            const { key, ...optionProps } = props;
                            return (
                              <li key={key} {...optionProps}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option.department_name}
                              </li>
                            );
                          }}
                          onChange={(event, newValue) => {
                            setSettings((prev) => ({
                              ...prev,
                              department_ids: newValue.map((a) => a.department_id)
                            }));
                          }}
                          renderInput={(params) =>
                            <TextField
                              fullWidth
                              {...params}
                              label="Department"
                              name="Department"
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />}
                        />
                        <Autocomplete
                          value={roomData.filter((c) => settings?.room_ids?.includes(c.room_id)) || []}
                          id="checkboxes-tags-demo"
                          size="small"
                          fullWidth
                          multiple
                          clearIcon={true}
                          disableCloseOnSelect
                          options={roomData}
                          disabled={!settings?.department_ids || settings?.department_ids?.length === 0}
                          getOptionLabel={(option) => `${option?.room_name} ${option.room_no ? `(${option.room_no})` : ''}`}
                          renderOption={(props, option, { selected }) => {
                            const { key, ...optionProps } = props;
                            return (
                              <li key={key} {...optionProps}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {`${option?.room_name} ${option.room_no ? `(${option.room_no})` : ''}`}
                              </li>
                            );
                          }}
                          onChange={(event, newValue) => {
                            setSettings((prev) => ({
                              ...prev,
                              room_ids: newValue.map((a) => a.room_id)
                            }));
                          }}
                          renderInput={(params) =>
                            <TextField
                              fullWidth
                              {...params}
                              label="Room"
                              name="Room"
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />}
                        />
                      </Box>
                    </Grid>) : ![ReportType[41], ReportType[20]]?.includes(reportType) && (
                      <Grid item xs={12} sm={12}>
                        <Box style={{ display: 'flex', gap: 5, alignItems: 'center', marginTop: 10 }}>
                          <Typography variant="body2">Report Filters: </Typography>
                          <Link
                            style={{
                              fontSize: 14,
                              textDecoration: 'none',
                              cursor: 'pointer'
                            }}
                            onClick={() => setFilterOpen(true)}
                          >
                            Add Filters
                          </Link>
                          {filters.length > 0 && (<Check color="primary" />)}
                        </Box>
                      </Grid>
                    )}

                    {/* Point In Time selector - only for ReportType[19] and ReportType[20] */}
                    {[ReportType[19], ReportType[20]].includes(reportType) && (
                      <Grid item xs={12} sm={12}>
                        <Box style={{ display: 'flex', gap: 5, alignItems: 'center', marginTop: 10 }}>
                          <Typography variant="body2">Point In Time: </Typography>
                          <Autocomplete
                            value={pointData.find((p) => p.pointin_time_id === settings?.pointintimeid) || null}
                            id="point-in-time-select"
                            size="small"
                            fullWidth
                            options={pointData}
                            getOptionLabel={(option) => option?.name || ''}
                            onChange={(event, newValue) => {
                              setSettings((prev) => ({
                                ...prev,
                                pointintimeid: newValue ? newValue.pointin_time_id : null
                              }));
                            }}
                            renderInput={(params) =>
                              <TextField
                                fullWidth
                                {...params}
                                label="Select Point In Time"
                                name="pointInTime"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            }
                          />
                        </Box>
                      </Grid>
                    )}

                    {([ReportType[13], ReportType[29]].includes(reportType)) && (
                      <Grid item xs={12} sm={12}>
                        <Box style={{ display: 'flex', gap: 5, marginTop: 6 }}>
                          <Typography variant="body2" style={{ marginTop: 7 }}>{reportType === ReportType[29] ? 'Reports To Include:' : 'Resources:'}</Typography>
                          <FormGroup>
                            {reportType === ReportType[29] && (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={settings?.includeRoomByRoomDetail}
                                      onChange={(e) => {
                                        setSettings((prev) => ({
                                          ...prev,
                                          includeRoomByRoomDetail: e.target.checked
                                        }));
                                        setColumns(e.target.checked ? previewRoomDataDetailColumns : []);
                                      }}
                                    />}
                                  label="Room Detail Report"
                                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={settings?.includeRoomByRoomSpec}
                                      onChange={(e) => {
                                        setSettings((prev) => ({
                                          ...prev,
                                          includeRoomByRoomSpec: e.target.checked
                                        }));
                                        setAnotherColumns(e.target.checked ? previewRoomDataSpecColumns : []);
                                      }}
                                    />}
                                  label="Room Detail Specification Report"
                                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={settings?.includeDataSheet}
                                      onChange={(e) => {
                                        setSettings((prev) => ({
                                          ...prev,
                                          includeDataSheet: e.target.checked,
                                          idLayout: idsLayout
                                        }))
                                      }}
                                    />}
                                  label="DataSheet Report"
                                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                />
                              </>
                            )}
                            {settings.includeDataSheet && (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={settings?.includeThumbnail}
                                      onChange={(e) => {
                                        setSettings((prev) => ({
                                          ...prev,
                                          includeThumbnail: e.target.checked
                                        }))
                                      }}
                                    />}
                                  label="Include Thumbnail"
                                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                  style={{ marginLeft: reportType === ReportType[29] ? '6%' : 0 }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={settings?.includeItemSpec}
                                      onChange={(e) => {
                                        setSettings((prev) => ({
                                          ...prev,
                                          includeItemSpec: e.target.checked
                                        }))
                                      }}
                                    />}
                                  label="Include Item Specification Sheet"
                                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                  style={{ marginLeft: reportType === ReportType[29] ? '6%' : 0 }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={settings?.includeProdSpec}
                                      onChange={(e) => {
                                        setSettings((prev) => ({
                                          ...prev,
                                          includeProdSpec: e.target.checked
                                        }));
                                      }}
                                    />}
                                  label="Include Product Specification Sheet"
                                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                  style={{ marginLeft: reportType === ReportType[29] ? '6%' : 0 }}
                                />
                                {reportType === ReportType[29] && (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={settings?.includeLongDesc}
                                        onChange={(e) => {
                                          setSettings((prev) => ({
                                            ...prev,
                                            includeLongDesc: e.target.checked
                                          }));
                                        }}
                                      />
                                    }
                                    label="Include Product Long Description on Coversheet"
                                    sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                    style={{ marginLeft: reportType === ReportType[29] ? '6%' : 0 }}
                                  />
                                )}
                              </>
                            )}
                          </FormGroup>
                        </Box>
                      </Grid>
                    )}
                    {([ReportType[31], ReportType[33], ReportType[34]].includes(reportType)) && (
                      <Grid item xs={12} sm={12}>
                        <Box style={{ display: 'flex', gap: 5, marginTop: 6 }}>
                          <Typography variant="body2" style={{ marginTop: 7 }}>Resources:</Typography>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={settings?.includeResources}
                                  onChange={(e) => {
                                    setSettings((prev) => ({
                                      ...prev,
                                      includeResources: e.target.checked
                                    }))
                                  }}
                                />}
                              label="Include Resources"
                              sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                              style={{ marginLeft: reportType === ReportType[29] ? '6%' : 0 }}
                            />
                          </FormGroup>
                        </Box>
                      </Grid>
                    )}
                    {reportType !== ReportType[29] && (
                      <Grid item xs={12} sm={12}>
                        <Box style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10 }}>
                          <Typography variant="body2">Output: </Typography>
                          <FormControl variant="standard" sx={{ minWidth: 120 }}>
                            <InputLabel id="demo-simple-select-standard-label">Export As</InputLabel>
                            <Select
                              labelId="demo-simple-select-standard-label"
                              id="demo-simple-select-standard"
                              value={settings?.outPut}
                              onChange={(e) => {
                                setSettings((prev) => ({
                                  ...prev,
                                  outPut: e.target.value
                                }));
                              }}
                              label="Export As"
                            >
                              {selectedReport.isPdf && (<MenuItem value="pdf">PDF</MenuItem>)}
                              {selectedReport.isExcel && (<MenuItem value="excel">Excel</MenuItem>)}
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                    )}
                    {reportType === ReportType[41] && (
                      <>
                        <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                          <Autocomplete
                            size="small"
                            fullWidth
                            options={tableNames}
                            value={filter.table}
                            onChange={(event, newValue) => {
                              setFilter((prev) => ({
                                ...prev,
                                table: newValue?.value
                              }))
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Object Type"
                                placeholder="Select Object Type"
                              />
                            )}
                          />
                        </Grid>
                        <Box style={{ display: 'flex', flexDirection: 'column', marginTop: 10 }}>
                          <Typography variant="body2">Date Range: </Typography>
                          <Grid container mt={1} spacing={1}>
                            <Grid item xs={12} sm={6}>
                              <FormControl size="small" fullWidth variant="outlined">
                                <InputLabel htmlFor="standard-adornment-password" shrink={filter?.from === null || filter?.from === '' || filter?.from}>From</InputLabel>
                                <OutlinedInput
                                  label="From"
                                  id="Date 1"
                                  type='date'
                                  value={filter?.from || ''}
                                  onChange={(e) => {
                                    setFilter((prev) => ({
                                      ...prev,
                                      from: moment(e.target.value).format('YYYY-MM-DD') || null
                                    }))
                                  }}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormControl size="small" fullWidth variant="outlined">
                                <InputLabel htmlFor="standard-adornment-password" shrink={filter?.to === null || filter?.to === '' || filter?.to}>To</InputLabel>
                                <OutlinedInput
                                  label="To"
                                  id="Date 2"
                                  type='date'
                                  value={filter.to}
                                  onChange={(e) => {
                                    setFilter((prev) => ({
                                      ...prev,
                                      to: moment(e.target.value).format('YYYY-MM-DD') || null
                                    }))
                                  }}
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    )}
                    {([ReportType[13], ReportType[29]].includes(reportType)) && (
                      <Grid item xs={12} sm={12}>
                        <Box style={{ display: 'flex', gap: 5, marginTop: 6, marginLeft: reportType === ReportType[29] ? '25%' : 0 }}>
                          {reportType !== ReportType[29] && (
                            <Box style={{ width: 100 }}>
                              <Typography variant="body2" style={{ marginTop: 7, fontWeight: 'bold' }}>DataSheet Detail Configuration: </Typography>
                            </Box>
                          )}
                          <FormGroup>
                            {reportType !== ReportType[29] && (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={settings?.includeLongDesc}
                                    onChange={(e) => {
                                      setSettings((prev) => ({
                                        ...prev,
                                        includeLongDesc: e.target.checked
                                      }));
                                    }}
                                  />
                                }
                                label="Include Product Long Description on Coversheet"
                                sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                              />
                            )}
                            {reportType !== ReportType[29] && (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={settings?.includeLocation}
                                    onChange={(e) => {
                                      setSettings((prev) => ({
                                        ...prev,
                                        includeLocation: e.target.checked
                                      }));
                                    }}
                                  />
                                }
                                label="Include Item Location List with Covertsheet"
                                sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                              />
                            )}
                          </FormGroup>
                        </Box>
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
            </Grid>
            {selectReport ? (
              <Grid item xs={12} sm={reportName !== null ? 8 : 9}>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Mvedas Reports</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                      <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                          <TableHead>
                            <TableRow>
                              <Cell style={{ width: '50px' }}></Cell>
                              <Cell style={{ width: '50px' }}><img src="/images/excel.jpg" alt="blog img" style={{ width: 20, paddingTop: 7 }} /></Cell>
                              <Cell style={{ width: '50px' }}><img src="/images/pdf.svg" alt="blog img" style={{ width: 20, paddingTop: 7 }} /></Cell>
                              <Cell style={{ width: 380 }}>Report</Cell>
                              <Cell>Detail</Cell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {ReportFormats.map(report => {
                              if (report.reportName === 'Procurement Reports' && (!user?.organization?.Subscriptions[0]?.is_procurement_assign && !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code))) {
                                return { ...report, children: [] }; // Set children to an empty array
                              }
                              return report; // Return all other reports unchanged
                            }).map((a, index) => (
                              <>
                                <TableRow
                                  key={index}
                                  sx={{ padding: 10, cursor: 'pointer', background: a.reportName === selectedReport?.reportName ? 'lightBlue' : 'white' }}
                                  onClick={() => {
                                    if (a.children.length === 0) {
                                      setSelectedReport(a)
                                    }
                                  }}>
                                  <Cell onClick={(e) => { e.stopPropagation(); toggleExpand(index); }}>
                                    {a.children.length > 0 &&
                                      (expandedRows.includes(index) ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />)}
                                  </Cell>
                                  <Cell>{a.isExcel && (<Check color="secondary" />)}</Cell>
                                  <Cell>{a.isPdf && (<Check color="secondary" />)}</Cell>
                                  <Cell style={{ width: 380 }}>{a.reportName}</Cell>
                                  <Cell>{a.detail}</Cell>
                                </TableRow>
                                {
                                  expandedRows.includes(index) && a.children.map((child, childIndex) => (
                                    <TableRow
                                      key={`child-${index}-${childIndex}`}
                                      sx={{ background: child.reportName === selectedReport?.reportName ? 'lightBlue' : '#f9f9f9', pl: 4, cursor: 'pointer' }}
                                      onClick={() => {
                                        setSelectedReport(child)
                                      }}
                                    >
                                      <Cell />
                                      <Cell>{child.isExcel && (<Check color="secondary" />)}</Cell>
                                      <Cell>{child.isPdf && (<Check color="secondary" />)}</Cell>
                                      <Cell>{child.reportName}</Cell>
                                      <Cell>{child.detail}</Cell>
                                    </TableRow>
                                  ))
                                }
                              </>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Custom Reports</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {customReports.length > 0 && (
                      <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                        <TableContainer>
                          <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                            <TableHead>
                              <TableRow>
                                <Cell style={{ width: '50px' }}></Cell>
                                <Cell style={{ width: '50px' }}><img src="/images/excel.jpg" alt="blog img" style={{ width: 20, paddingTop: 7 }} /></Cell>
                                <Cell style={{ width: '50px' }}><img src="/images/pdf.svg" alt="blog img" style={{ width: 20, paddingTop: 7 }} /></Cell>
                                <Cell style={{ width: 380 }}>Report</Cell>
                                <Cell>Detail</Cell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {customReports.map((a, index) => (
                                <>
                                  <TableRow
                                    key={index}
                                    sx={{ padding: 10, cursor: 'pointer', background: a.report_id === selectedReport?.report_id ? 'lightBlue' : 'white' }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setSelectedReport((prev) => ({
                                        ...a,
                                        isExcel: a.output === 'excel',
                                        isPdf: a.output === 'pdf'
                                      }));
                                    }}>
                                    <Cell>
                                      <Tooltip title="Delete Report">
                                        <DeleteOutline
                                          color="secondary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setDeleteOpen(true);
                                            setReportId(a.report_id);
                                          }}
                                        />
                                      </Tooltip>
                                    </Cell>
                                    <Cell>{a.output === 'excel' && (<Check color="secondary" />)}</Cell>
                                    <Cell>{a.output === 'pdf' && (<Check color="secondary" />)}</Cell>
                                    <Cell style={{ width: 380 }}>{a.name}</Cell>
                                    <Cell>{a.description}</Cell>
                                  </TableRow>
                                </>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    )}
                  </AccordionDetails>
                </Accordion>
                <Box display="flex" justifyContent="flex-end" gap={1} mt={1}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => {
                      setSelectReport(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                      if (selectedReport !== null) {
                        setSelectReport(false);
                        setReportName(selectedReport.reportName || selectedReport.name);
                        setSavedReport(selectedReport.name || `${selectedReport.reportName}-${moment().format('YYYY-MM-DD HH:MM A')}`);
                        setDescription(selectedReport.description || selectedReport.detail);
                        if (selectedReport.type) {
                          setReportType(selectedReport.type);
                        } else {
                          for (const parent of ReportFormats) {
                            const child = parent.children.find(b => selectedReport.name.includes(b.reportName));
                            if (child) {
                              setReportType(child.type);
                              break;
                            }
                          }
                        }
                        if (selectedReport.settings) {
                          setSettings(selectedReport.settings);
                        } else {
                          if (selectedReport.type === ReportType[13]) {
                            setSettings({
                              includeThumbnail: true,
                              includeItemSpec: false,
                              includeProdSpec: true,
                              outPut: selectedReport.isPdf ? 'pdf' : selectedReport.isExcel ? 'excel' : null,
                              includeLongDesc: false,
                              includeLocation: true,
                              idLayout: idsLayout,
                              headingLayout: headingsLayout,
                              marginLayout: marginsLayout,
                              clientLogo: null,
                              organizationLogo: null,
                              pageBreak: false,
                              includeDataSheet: true,
                              includeResources: false,
                            })
                          } else if ([ReportType[1], ReportType[2], ReportType[3],
                          ReportType[4], ReportType[5], ReportType[6],
                          ReportType[7], ReportType[8], ReportType[9],
                          ReportType[10], ReportType[11], ReportType[12], ReportType[28]].includes(selectedReport.type)) {
                            setSettings({
                              outPut: selectedReport.isPdf ? 'pdf' : selectedReport.isExcel ? 'excel' : null,
                              headingLayout: headingsLayout,
                              marginLayout: marginsLayout,
                              idLayout: null,
                              clientLogo: null,
                              organizationLogo: null,
                              includeLocation: false,
                              pageBreak: false,
                              configuration: 0
                            });
                          } else if (selectedReport.type === ReportType[29]) {
                            setSettings({
                              includeThumbnail: true,
                              includeItemSpec: false,
                              includeProdSpec: true,
                              outPut: selectedReport.isPdf ? 'pdf' : selectedReport.isExcel ? 'excel' : null,
                              includeLongDesc: false,
                              includeLocation: false,
                              idLayout: idsLayout,
                              headingLayout: headingsLayout,
                              marginLayout: marginsLayout,
                              clientLogo: null,
                              organizationLogo: null,
                              includeDataSheet: true,
                              includeRoomByRoomDetail: true,
                              includeRoomByRoomSpec: true,
                              includeResources: false,
                            });
                            setAnotherColumns(previewRoomDataSpecColumns);
                          } else {
                            setSettings({
                              outPut: selectedReport.isPdf ? 'pdf' : selectedReport.isExcel ? 'excel' : null,
                              headingLayout: headingsLayout,
                              marginLayout: marginsLayout,
                              idLayout: selectedReport.type === ReportType[16] ? locationIdLayout : null,
                              clientLogo: null,
                              organizationLogo: null,
                              includeLocation: true,
                              pageBreak: false,
                              pointintimeid: null,
                            });
                          }
                        }
                        if (selectedReport?.columns?.length > 0) {
                          setAnotherColumns(selectedReport?.columns);
                        }

                        if (selectedReport?.fields?.length > 0) {
                          setColumns(selectedReport.fields);
                        } else if (selectedReport.type === ReportType[13]) {
                          setColumns(previewDataSheetColumns);
                        } else if (selectedReport.type === ReportType[14]) {
                          setColumns(previewDataSheetTableColumns);
                        } else if (selectedReport.type === ReportType[15]) {
                          setColumns(previewItemDetailColumns);
                        } else if (selectedReport.type === ReportType[16]) {
                          setColumns(previewItemLocColumns);
                        } else if (selectedReport.type === ReportType[17]) {
                          setColumns(previewItemSpecColumns);
                        } else if (selectedReport.type === ReportType[18]) {
                          setColumns(previewItemSummary);
                        } else if (selectedReport.type === ReportType[23]) {
                          setColumns(prevColRoomListPrice)
                        } else if (selectedReport.type === ReportType[24]) {
                          setColumns(prevColRoomListWithoutPrice)
                        } else if (selectedReport.type === ReportType[25]) {
                          setColumns(prevColRoomDetailWithPrice)
                        } else if (selectedReport.type === ReportType[26]) {
                          setColumns(prevColRoomDetailWithoutPrice)
                        } else if (selectedReport.type === ReportType[27]) {
                          setColumns(previewItemSpecColumns);
                        } else if (selectedReport.type === ReportType[21]) {
                          setColumns(previewProjectCeritifiColumns);
                        } else if (selectedReport.type === ReportType[22]) {
                          setColumns(previewProjectItemSummColumns);
                        } else if (selectedReport.type === ReportType[29]) {
                          setColumns(previewRoomDataDetailColumns);
                        } else if ([ReportType[31], ReportType[32], ReportType[33], ReportType[35], ReportType[36], ReportType[37], ReportType[38]].includes(selectedReport.type)) {
                          setColumns(previewProcurementColumns);
                        } else if (selectedReport.type === ReportType[34]) {
                          setColumns(previewProcurementColumns.slice(0, 6));
                        } else if (selectedReport.type === ReportType[30]) {
                          setColumns(previewPOActionColumns);
                        } else if (selectedReport.type === ReportType[39]) {
                          setColumns(previewProcurementScheduleColumns);
                        } else if (selectedReport.type === ReportType[40]) {
                          setColumns(previewPoSummaryColumns);
                        } else if (selectedReport.type === ReportType[19]) {
                          setColumns(previewPointIntimeColumns);
                        } else {
                          setColumns([]);
                        }
                        setSortBy(selectedReport?.sortby?.toString());
                        setGroupBy(selectedReport.groupby?.length > 0 ? selectedReport.groupby : []);
                      } else {
                        showNotification('Please select any report', 'error');
                      }
                    }}
                  >
                    Apply
                  </Button>
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12} sm={8}>
                <Box style={{ marginTop: 10 }}>
                  <Typography variant="body2">{description}</Typography>
                </Box>
              </Grid>
            )}
            {(reportName !== null && !selectReport) && (
              <>
                {((reportType === ReportType[13] || settings.includeDataSheet) && ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) && (
                  <Grid item xs={12} style={{ marginLeft: reportType === ReportType[29] ? '9%' : '5.7%' }}>
                    <Typography variant="body2" fontWeight="bold"> ID Layout:</Typography>
                    <DragDrop
                      data={settings?.idLayout}
                      setData={(newIdLayoutUpdater) => {
                        setSettings((prevSettings) => ({
                          ...prevSettings,
                          idLayout: typeof newIdLayoutUpdater === 'function'
                            ? newIdLayoutUpdater(prevSettings.idLayout)
                            : newIdLayoutUpdater,
                        }));
                      }}
                    />
                  </Grid>
                )}
                {([ReportType[15], ReportType[18], ReportType[21], ReportType[22], ReportType[28], ReportType[39], ReportType[40], ReportType[19]].includes(reportType)) && (
                  <Grid item xs={12} sm={12}>
                    <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                      <Typography variant="body2" style={{ marginTop: 14 }}>Group By: </Typography>
                      <FormControl variant="standard" sx={{ minWidth: 300 }}>
                        <Autocomplete
                          multiple
                          size="small"
                          options={groupingFields.filter((a) => {
                            if (reportType === ReportType[30]) {
                              return !['department_id', 'category_id', 'sub_category_id', 'description'].includes(a.value);
                            } else if ([ReportType[39], ReportType[40]].includes(reportType)) {
                              return !['vender_id', 'sub_category_id'].includes(a.value);
                            } else {
                              return !['vender_id'].includes(a.value);
                            }
                          })}
                          clearIcon={true}
                          getOptionLabel={(option) => option.title}
                          value={groupingFields.filter((f) => groupby.includes(f.value))}
                          onChange={(event, newValue) => {
                            if (newValue.length > 3) {
                              showNotification('You can select a maximum of 3 options', 'error');
                              return;
                            }
                            const selectedValues = newValue.map((item) => item.value);
                            setGroupBy(selectedValues);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label="Group By"
                            />
                          )}
                        />
                      </FormControl>
                    </Box>
                  </Grid>
                )}
                {![ReportType[29], ReportType[30], ReportType[41], ReportType[20]].includes(reportType) && (
                  <>
                    <Grid item xs={12} sm={12}>
                      <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                        <Typography variant="body2" style={{ marginTop: 14 }}>Sort By: </Typography>
                        <FormControl variant="standard" sx={{ minWidth: 300 }}>
                          <InputLabel id="demo-simple-select-standard-label">Sort By</InputLabel>
                          <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            value={sortby}
                            onChange={(e) => setSortBy(e.target.value)}
                            label="Sort By"
                          >
                            <MenuItem value="">Select</MenuItem>
                            {sortingFields.filter((a) => {
                              const specialReports = [ReportType[31], ReportType[32],
                              ReportType[33], ReportType[34], ReportType[35],
                              ReportType[36], ReportType[37], ReportType[38]];
                              if (specialReports?.includes(reportType)) {
                                if ([ReportType[31], ReportType[34], ReportType[35],
                                ReportType[36]].includes(reportType)) {
                                  return ['action_id', 'action_no', 'vender_id'].includes(a.value);
                                } else {
                                  return ['action_id', 'action_no',].includes(a.value);
                                }
                              } else if (reportType === ReportType[39]) {
                                return !['action_id', 'action_no', 'vender_id', 'custom_id_1', 'custom_id_2', 'inventory_id', 'pa_id', 'category_name'].includes(a.value);
                              } else if (reportType === ReportType[40]) {
                                return !['action_id', 'vender_id', 'custom_id_1', 'custom_id_2', 'inventory_id', 'pa_id', 'category_name'].includes(a.value);
                              } else if (reportType === ReportType[30]) {
                                return !['action_id', 'category_name', 'custom_id_1', 'custom_id_2', 'inventory_id'].includes(a.value);
                              } else {
                                return !['action_id', 'action_no', 'vender_id', 'pa_id'].includes(a.value);
                              }
                            }).map((a) => {
                              const item = { ...a };

                              // Customize titles based on reportType
                              switch (reportType) {
                                case ReportType[31]:
                                case ReportType[35]:
                                  if (item.value === 'action_id') item.title = 'Requisition ID';
                                  if (item.value === 'action_no') item.title = 'Requisition #';
                                  break;
                                case ReportType[32]:
                                case ReportType[36]:
                                  if (item.value === 'action_id') item.title = 'Bid ID';
                                  if (item.value === 'action_no') item.title = 'Bid #';
                                  break;
                                case ReportType[33]:
                                case ReportType[37]:
                                  if (item.value === 'action_id') item.title = 'RFQ ID';
                                  if (item.value === 'action_no') item.title = 'RFQ #';
                                  break;
                                case ReportType[34]:
                                case ReportType[38]:
                                case ReportType[40]:
                                case ReportType[30]:
                                  if (item.value === 'action_id') item.title = 'PO ID';
                                  if (item.value === 'action_no') item.title = 'PO #';
                                  break;
                                default:
                                  break;
                              }

                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.title}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                    {![ReportType[32], ReportType[35], ReportType[36], ReportType[37], ReportType[19], ReportType[38]].includes(reportType) && (
                      <Grid item xs={12} sm={12}>
                        <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                          <Typography variant="body2">Page Break: </Typography>
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="demo-radio-buttons-group-label"
                              value={settings?.pageBreak ? 'yes' : 'no'}
                              name="radio-buttons-group"
                              onChange={(e) => {
                                setSettings((prev) => ({
                                  ...prev,
                                  pageBreak: e.target.value === 'yes' ? true : false
                                }))
                              }}
                            >
                              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" control={<Radio />} label="No" />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </Grid>
                    )}
                  </>
                )}
                {reportType === ReportType[10] && (
                  <Grid item xs={12} sm={12}>
                    <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                      <Typography variant="body2" style={{ marginTop: 14 }}>Configuration: </Typography>
                      <TextField
                        label="Configuration"
                        name="configuration"
                        variant="standard"
                        size='small'
                        type="number"
                        value={settings.configuration}
                        onChange={(e) => {
                          setSettings((prev) => ({
                            ...prev,
                            configuration: e.target.value
                          }))
                        }}
                      />
                    </Box>
                  </Grid>)}
                {![ReportType[35], ReportType[36], ReportType[37], ReportType[38], ReportType[41], ReportType[20]].includes(reportType) && (
                  <Grid item xs={12} md={12}>
                    <Box style={{ display: 'flex', gap: 5, alignItems: 'center', marginTop: 10 }}>
                      <Typography variant="body2">Layout: </Typography>
                      <Box style={{ display: 'flex', alignItems: 'center' }}>
                        <Link
                          style={{
                            fontSize: 14,
                            textDecoration: 'none',
                            cursor: 'pointer'
                          }}
                          onClick={() => setLayoutEdit(!isLayoutEdit)}
                        >
                          Edit Report Layout
                        </Link>
                        <KeyboardArrowRightIcon color="primary" />
                      </Box>
                    </Box>
                  </Grid>
                )}
              </>
            )}
          </Grid>
          {(reportName !== null && !selectReport && settings?.includeLocation && ![ReportType[20], ReportType[41]]?.includes(reportType)) && (
            <>
              <Divider />
              {(['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && ![ReportType[32], ReportType[35], ReportType[36], ReportType[37], ReportType[38]].includes(reportType)) && (
                <>
                  <Typography variant="body1" style={{ fontWeight: 'bold' }} mt={1}>Report Preview</Typography>
                  <Typography variant="body2" mt={1}>To configure the columns of your report, search for fields add, then drag and drop fields to arrange column order and groupings.</Typography>
                  <Typography variant="body2" mt={2} style={{ fontSize: 12 }}><span style={{ fontWeight: 'bold' }}>Note:</span> One or more column must be selected to generate report</Typography>
                  <DynamicTable
                    columns={[ReportType[31], ReportType[32], ReportType[33], ReportType[34], ReportType[35], ReportType[36], ReportType[37], ReportType[38]].includes(reportType) ? columns.map((a) => {
                      if (a?.subHeaders) {
                        // Modify subHeaders array
                        const updatedSubHeaders = a.subHeaders.map((d) => {
                          if (d.field === 'quantity') {
                            return {
                              ...d, // Spread existing properties of subHeader
                              title: 'Qty',
                              field: 'extended_item_quantity' // Update the field value in subHeader
                            }
                          }
                          if (d.field === 'list_price') {
                            return {
                              ...d,
                              title: 'Unit Cost'
                            }
                          }
                          return d; // Return unchanged subHeader if condition is not met
                        });

                        return {
                          ...a, // Spread the top-level object
                          subHeaders: updatedSubHeaders // Update subHeaders with modified values
                        };
                      }

                      return a; // Return the object unchanged if no subHeaders exist
                    }) : columns}
                    setColumns={setColumns}
                    reportType={reportType}
                  />
                </>
              )}
              {![ReportType[32], ReportType[35], ReportType[36], ReportType[37], ReportType[38]].includes(reportType) && (
                <Card sx={{ marginTop: 3, padding: 2 }}>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Header Column (A4 {`${([ReportType[13], ReportType[29]].includes(reportType)) ? 'Portrait' : 'Landscape'}`})</Typography>
                  <table cellPadding="8" style={{
                    borderCollapse: 'collapse',
                    width: '100%',
                    margin: '10px 0',
                    fontSize: '14px',
                    textAlign: 'left',
                    border: '1px solid #ccc'
                  }}>
                    <thead>
                      {
                        // Calculate max depth for subHeaders to organize rows
                        Array.from(
                          { length: Math.max(...columns.map((group) => group.subHeaders.length)) },
                          (_, rowIndex) => (
                            <tr key={`row-${rowIndex}`}>
                              {columns.map((group, colIndex) => {
                                const subHeader = group.subHeaders[rowIndex];
                                return (
                                  <th key={`header-${rowIndex}-${colIndex}`} style={{ padding: '6px' }}>
                                    {subHeader ? subHeader.title : ""}
                                  </th>
                                );
                              })}
                            </tr>
                          )
                        )
                      }
                    </thead>
                  </table>

                </Card>
              )}
            </>
          )}
          {(reportName !== null && !selectReport && settings?.includeRoomByRoomDetail && ![ReportType[19], ReportType[20], ReportType[41]]?.includes(reportType)) && (
            <>
              <Divider />
              {['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && (
                <>
                  <Typography variant="body1" style={{ fontWeight: 'bold' }} mt={1}>Room Detail Report Preview</Typography>
                  <Typography variant="body2" mt={1}>To configure the columns of your report, search for fields add, then drag and drop fields to arrange column order and groupings.</Typography>
                  <Typography variant="body2" mt={2} style={{ fontSize: 12 }}><span style={{ fontWeight: 'bold' }}>Note:</span> One or more column must be selected to generate report</Typography>
                  <DynamicTable
                    columns={columns}
                    setColumns={setColumns}
                    reportType={reportType}
                  />
                </>
              )}
              <Card sx={{ marginTop: 3, padding: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Header Column (A4 {`${([ReportType[13], ReportType[29]].includes(reportType)) ? 'Portrait' : 'Landscape'}`})</Typography>
                <table cellPadding="8" style={{
                  borderCollapse: 'collapse',
                  width: '100%',
                  margin: '10px 0',
                  fontSize: '14px',
                  textAlign: 'left',
                  border: '1px solid #ccc'
                }}>
                  <thead>
                    {
                      // Calculate max depth for subHeaders to organize rows
                      Array.from(
                        { length: Math.max(...columns.map((group) => group.subHeaders.length)) },
                        (_, rowIndex) => (
                          <tr key={`row-${rowIndex}`}>
                            {columns.map((group, colIndex) => {
                              const subHeader = group.subHeaders[rowIndex];
                              return (
                                <th key={`header-${rowIndex}-${colIndex}`} style={{ padding: '6px' }}>
                                  {subHeader ? subHeader.title : ""}
                                </th>
                              );
                            })}
                          </tr>
                        )
                      )
                    }
                  </thead>
                </table>

              </Card>
            </>
          )}
          {(reportName !== null && !selectReport && settings?.includeRoomByRoomSpec && ![ReportType[19], ReportType[20], ReportType[41]]?.includes(reportType)) && (
            <>
              <Divider />
              {['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && (
                <>
                  <Typography variant="body1" style={{ fontWeight: 'bold' }} mt={1}>Room Detail Specification Report Preview</Typography>
                  <Typography variant="body2" mt={1}>To configure the columns of your report, search for fields add, then drag and drop fields to arrange column order and groupings.</Typography>
                  <Typography variant="body2" mt={2} style={{ fontSize: 12 }}><span style={{ fontWeight: 'bold' }}>Note:</span> One or more column must be selected to generate report</Typography>
                  <DynamicTable
                    columns={anotherColumns}
                    setColumns={setAnotherColumns}
                    reportType={reportType}
                  />
                </>
              )}
              <Card sx={{ marginTop: 3, padding: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Header Column (A4 {`${([ReportType[13], ReportType[29]].includes(reportType)) ? 'Portrait' : 'Landscape'}`})</Typography>
                <table cellPadding="8" style={{
                  borderCollapse: 'collapse',
                  width: '100%',
                  margin: '10px 0',
                  fontSize: '14px',
                  textAlign: 'left',
                  border: '1px solid #ccc'
                }}>
                  <thead>
                    {
                      // Calculate max depth for subHeaders to organize rows
                      Array.from(
                        { length: Math.max(...anotherColumns.map((group) => group.subHeaders.length)) },
                        (_, rowIndex) => (
                          <tr key={`row-${rowIndex}`}>
                            {anotherColumns.map((group, colIndex) => {
                              const subHeader = group.subHeaders[rowIndex];
                              return (
                                <th key={`header-${rowIndex}-${colIndex}`} style={{ padding: '6px' }}>
                                  {subHeader ? subHeader.title : ""}
                                </th>
                              );
                            })}
                          </tr>
                        )
                      )
                    }
                  </thead>
                </table>

              </Card>
            </>
          )}
        </Box>
      )}
      {activeTab === 1 && isDataAvailable && (
        <Button
          size="small"
          variant="outlined"
          color="primary"
          style={{ marginTop: 10, float: 'right' }}
          onClick={() => {
            setActivePage((prevData) => prevData + 1);
            getReportHistory(activePage + 1);
          }}
        >
          Load More
        </Button>
      )}
      {activeTab === 1 && (
        <Grid container spacing={2} mt={1}>
          {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
          {reportData.length > 0 ? reportData.filter((i) => i.status !== 'failed').map((a) => (
            <Grid item xs={12} sm={3}>
              <Card>
                <Box style={{ background: 'lightblue', padding: '10px' }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box style={{
                      background: "#1976d2",
                      color: "white",
                      padding: '3px 10px',
                      borderRadius: 16,
                      fontSize: 12
                    }}>
                      {a.output_type}
                    </Box>
                    <Box display="flex" gap={1} alignItems="center">
                      {a.status === 'completed' ? (
                        <Download
                          color="primary"
                          style={{ cursor: 'pointer' }}
                          onClick={async () => {
                            const url = `${process.env.REACT_APP_IMAGEURL}bbn=${a.output_file_url}&uid=${user?.user_id}`;
                            const response = await fetch(url, { method: 'GET' });
                            const blob = await response.blob();
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = `${a.name}.${a.output_type === 'pdf' ? 'pdf' : 'xlsx'}`; // <-- set file name here
                            link.click();
                          }}
                        />
                      ) : <CircularProgress style={{ width: 20, height: 20 }} />}
                      <DeleteOutline
                        color="secondary"
                        style={{ cursor: 'pointer' }}
                        onClick={async () => {
                          try {
                            setDataLoading(true);
                            const response = await apiRequest('delete', `/report/report-history/${a.report_history_id}`);
                            showNotification(response.data?.message, 'success');
                            setReportData([]);
                            getReportHistory(1);
                            setDataLoading(false);
                          } catch (error) {
                            setDataLoading(false);
                            showNotification(error?.response?.data.error || error.message, 'error');
                          }
                        }}
                      />
                    </Box>
                  </Box>
                  <Box style={{ height: '200px', marginTop: 10, background: 'gray' }} />
                </Box>
                <Box style={{ padding: '10px' }}>
                  <Typography style={{ fontSize: '14px', fontWeight: 'bold' }}>{a.name}</Typography>
                  <Typography style={{ fontSize: '14px' }}>Project: {a.project?.name}</Typography>
                  <Typography style={{ fontSize: '14px' }}>Filters By: {a.type !== 'Project History' && a.filters?.length > 0 ? a.filters?.map((i) => i.field)?.toString() : '--'}</Typography>
                  <Typography style={{ fontSize: '14px' }}>Group By: {(a.groupby !== "" && a.groupby !== null) ? groupingFields.filter((i) => typeof a.groupby === 'string' ? a.groupby === i.value : a.groupby.includes(i.value))?.map((e) => e.title)?.toString() : '--'}</Typography>
                  <Typography style={{ fontSize: '14px' }}>Sort By: {sortingFields.find((i) => i.value === a.sortby)?.title || '--'}</Typography>
                  <Typography style={{ fontSize: '14px' }}>{`${a.created_user?.first_name} ${a.created_user?.last_name ?? ''} || ${moment(a.created_at).format('YYYY-MM-DD hh:mm:ss A')}`}</Typography>
                </Box>
              </Card>
            </Grid>
          )) : !dataLoading && (
            <Box style={{ left: '50%', top: '50%', position: 'fixed' }}>
              <Typography variant="body1">No Report Found</Typography>
            </Box>
          )}
        </Grid>
      )
      }
      <Drawer
        anchor="right"
        open={filterOpen}
        sx={{
          '& .MuiDrawer-paper': {
            width: 350
          }
        }}
      >
        <FilterPanel
          projectId={projectId}
          reportType={reportType}
          applyFilter={(filters) => {
            setFilterOpen(false);
            setFilters(filters);
          }}
        />
      </Drawer>
      <Drawer
        anchor="right"
        open={isLayoutEdit}
        sx={{
          '& .MuiDrawer-paper': {
            width: 660
          }
        }}
      >
        <CustomFilterPanelWrapper>
          <DemoBox1>
            <Typography variant='body1' style={{ fontWeight: 'bold' }}>Report Layout Settings</Typography>
            <IconButton onClick={() => handleClose()}>
              <ClearIcon />
            </IconButton>
          </DemoBox1>
          <Divider />
          <FilterContent>
            {!fromAdmin && (
              <Box>
                <Typography variant="body2" fontWeight="bold">Logo</Typography>
                <Box display="flex" gap={2}>
                  <FormControl variant="standard" sx={{ minWidth: 300, marginTop: 2 }}>
                    <InputLabel id="demo-simple-select-standard-label">Organization Logo to include</InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={settings?.organizationLogo || ''}
                      onChange={(e) => {
                        setSettings((prev) => ({
                          ...prev,
                          organizationLogo: e?.target?.value
                        }));
                      }}
                      label="Organization Logo to include"
                      renderValue={(selected) => (
                        selected ? (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                              src={`${process.env.REACT_APP_IMAGEURL}bbn=${selected?.sortUrl}&uid=${user?.user_id}`}
                              alt="selected-logo"
                              style={{ width: 20, height: 20, marginRight: 10 }}
                            />
                            <Typography>{organization?.org_name || ''}</Typography>
                          </div>
                        ) : ''
                      )}
                    >
                      {organization?.logo_urls?.map((a) => (
                        <MenuItem value={a}>
                          <img src={`${process.env.REACT_APP_IMAGEURL}bbn=${a.sortUrl}&uid=${user?.user_id}`} style={{ width: '20px', height: '20px' }} alt="img" />
                          <Typography style={{ marginLeft: 10 }}>{organization?.org_name}</Typography>
                        </MenuItem>
                      ))}
                    </Select>
                    {settings?.organizationLogo && (
                      <IconButton
                        onClick={() => setSettings((prev) => ({ ...prev, organizationLogo: '' }))}
                        style={{ position: 'absolute', right: 0, top: 0 }}
                      >
                        <ClearIcon style={{ marginTop: 12, marginRight: 12 }} />
                      </IconButton>
                    )}
                  </FormControl>
                  <FormControl variant="standard" sx={{ minWidth: 300, marginTop: 2 }}>
                    <InputLabel id="demo-simple-select-standard-label">Client Logo to include</InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={settings?.clientLogo || ''}
                      onChange={(e) => {
                        setSettings((prev) => ({
                          ...prev,
                          clientLogo: e.target.value
                        }));
                      }}
                      label="Client Logo to include"
                      renderValue={(selected) => (
                        selected ? (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                              src={`${process.env.REACT_APP_IMAGEURL}bbn=${selected.sortUrl}&uid=${user?.user_id}`}
                              alt="selected-logo"
                              style={{ width: 20, height: 20, marginRight: 10 }}
                            />
                            <Typography>{clientOrganization || ''}</Typography>
                          </div>
                        ) : ''
                      )}
                    >
                      {clientLogos && clientLogos?.map((a) => (
                        <MenuItem key={a.sortUrl} value={a}>
                          <img
                            src={`${process.env.REACT_APP_IMAGEURL}bbn=${a.sortUrl}&uid=${user?.user_id}`}
                            style={{ width: '20px', height: '20px' }}
                            alt="img"
                          />
                          <Typography style={{ marginLeft: 10 }}>{clientOrganization}</Typography>
                        </MenuItem>
                      ))}
                    </Select>
                    {settings?.clientLogo && (
                      <IconButton
                        onClick={() => setSettings((prev) => ({ ...prev, clientLogo: '' }))}
                        style={{ position: 'absolute', right: 0, top: 0 }}
                      >
                        <ClearIcon style={{ marginTop: 12, marginRight: 12 }} />
                      </IconButton>
                    )}
                  </FormControl>
                </Box>
              </Box>
            )}
            {['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && (
              <Box mt={!fromAdmin ? 3 : 0}>
                <Typography variant="body2" fontWeight="bold">Page Layout</Typography>
                <Box mt={2}>
                  <Typography variant="body2">Header Layout</Typography>
                  <DragDrop
                    data={settings?.headingLayout}
                    setData={(newHeadingLayoutUpdater) => {
                      setSettings((prevSettings) => ({
                        ...prevSettings,
                        headingLayout: typeof newHeadingLayoutUpdater === 'function'
                          ? newHeadingLayoutUpdater(prevSettings.headingLayout)
                          : newHeadingLayoutUpdater,
                      }));
                    }}
                    heading
                  />
                </Box>
                <Box mt={2}>
                  <Typography variant="body2">Margin Text Layout</Typography>
                  <DragDrop
                    data={settings?.marginLayout}
                    setData={(newMarginLayoutUpdater) => {
                      setSettings((prevSettings) => ({
                        ...prevSettings,
                        marginLayout: typeof newMarginLayoutUpdater === 'function'
                          ? newMarginLayoutUpdater(prevSettings.marginLayout)
                          : newMarginLayoutUpdater,
                      }));
                    }}
                    heading
                  />
                </Box>
              </Box>
            )}
          </FilterContent>
          <FilterFooter>
            <FixedButton variant="outlined" color="primary" onClick={() => handleClose()}>Cancel</FixedButton>
            <FixedButton variant="contained" color="primary" onClick={() => handleClose()}>Save</FixedButton>
          </FilterFooter>
        </CustomFilterPanelWrapper>
      </Drawer>
    </Box >
  )
}

export default Reports;